export const START_ANAGRAMS_GAME_COMPLETED = "anagrams/startGameCompleted";
export const GUESS_ANAGRAMS_COMPLETED = "anagrams/guessCompleted";
export const GET_ANAGRAMS_STATUS_COMPLETED = "anagrams/statusCompleted";
